<script>
// import request from '@/found/utils/request';
import Form, { formCreate } from '@/found/components/form';

export default {
  extends: Form,
  components: {

  },
  props: {
    parentCode: String,
    formType: String,
    functionName: String,
    field: String,
    value: Object,
    titleName: String,
  },
  data() {
    return {
      rule: [],
      buttons: {
        submit: false,
        close: false,
      },
      // eslint-disable-next-line max-len
      defaultValue: '<p>一、经销关系确立</p><p>甲、乙双方根据本合同确立经销关系，即乙方在甲方规定的区域内拥有甲方产品的经销权（该经销关系完全属于买卖法律关系），除非甲、乙双方另有书面约定，乙方无权代甲方做出任何</p><p>承诺或立下任何义务。</p><p><br></p><p>二、经销区域及期限</p><p>1、甲方授权乙方为甲方 系列</p><p>产品在 区域内（以国家行政区域划分为准）的经销商。具体经销产品、规格及价格明细（见合同附件二）。</p><p>2、经销期限：自 2020 年 月 日起至 2020 年 12 月 20 日止。</p><p>销售任务、销售折扣、年度折扣及相关政策核算期限（结算期限）：自 2020年 月 日起至 2020 年 12 月 20 日止。</p><p>3、特别约定：如果乙方在本合同期内无违约行为并遵守甲方各项业务安排的，本合同到期后经双方协商一致后可再续签合同。</p><p><br></p><p>三、交货方式</p><p>1、由甲、乙双方共同确定的配送服务公司负责送货到乙方指定库房，配送及运输费用由乙方承担，如果因乙方原因需要调整交货地址，须提前五天以书面</p><p>形式告知甲方，获取甲方确认后送货至新指定地点。</p><p>2、乙方在送货凭证上签收后，产品所有权和风险即从甲方转移到乙方。若无甲方书面签章公文许可，甲方任何人员不得随意调货或借货。</p><p>3、乙方收到甲方货物后，必须将加盖乙方印章或由其指定代表（以附件一登记为准）签字的收货回执交给甲方，并详细列明所收货物品项、数量及金额。</p><p>4、为保证产品配送的及时性及合理性，乙方购货计划必须达到甲方规定的最低配货量标准（具体标准另行通知），否则甲方不予配送。甲方将在确认收款后一周内配送。</p><p><br></p><p>四、结算方式</p><p>双方约定采用先付款后发货方式进行交易，即乙方在提交书面购货计划后三日内，应将相应全部货款汇入甲方指定账户。</p><p>1、甲方在确认货款到账后发出货物。</p><p>2、如甲方更改账号，以甲方财务部门盖章后的书面通知为准。</p><p>3、乙方汇款账户必须为法人账户、法定代表人个人账户、个体户经营者个人账户（以附件一登记为准），其他账户概不接受。</p><p>4、除非得到甲方财务部门盖章的书面通知，乙方不得将货款交给甲方业务人员或其他人员。否则，甲方视为未收到该笔货款，其法律责任由乙方自行承担。</p><p><br></p><p>五、销售目标及任务分解（见附件二）。</p><p><br></p><p>六、销售激励政策（见附件二）。</p><p><br></p><p>七、甲方的权利和义务</p><p>1、向乙方提供质量合格的产品，即符合国家 GB/T10781.1-2006 质量标准。同时向乙方提供必要的相关资料和产品检验报告。</p><p>2、协助并督促乙方进行市场开拓和销售工作，提供必要的市场指导和促销支持（以甲、乙双方书面共同确认的促销支持约定为准）。</p><p>3、合同期内，甲方有权根据市场行情随时调整供货价格，并以书面形式通知乙方。调价通知必须以正式行文传真或专人送达给乙方；书面通知作为本合同的附件。</p><p>4、甲方对乙方违反本合同及附件各项义务有权做出处置，直至取消乙方经销权，并保留追究相关法律责任的权利。</p><p>5、甲方须兑现以书面形式所承诺的各种支持，包括给乙方的各项激励政策、广告及营销推广费用等，但口头承诺和甲方员工个人承诺无效。</p><p>6、甲方根据市场具体情况，统一在电视台、广播电台、报纸等媒体有选择性地进行品牌广告宣传。</p><p><br></p><p>八、乙方的权利和义务</p><p>1、乙方须维护甲方及其产品的形象和声誉，主动做好该市场的销售及售后服务工作。</p><p>2、乙方不得从甲方以外的第三方购进甲方产品。</p><p>3、乙方须提供甲方要求的人力、配送车辆、仓储面积，以保证快捷准确地将经销产品配送到位。</p><p>4、乙方不得在其代理区域外销售。乙方须配备甲方要求的业务员，除正常销售以外，还需积极配合甲方维护市场、收集信息、反馈信息，以便共同运营市场。</p><p>5、乙方不得以任何形式借给或赠予甲方员工个人现金和物品。乙方因私自借予或赠予所造成的一切后果及损失，由乙方自行承担；由此给甲方造成损失的，甲方有权追究。</p><p>6、乙方应积极落实并自觉遵守甲方制定的关于市场开拓及市场维护等政策、决定。</p><p>7、乙方不得销售假冒甲方产品及产品商标、专利之任何侵权产品，如发现市场有假冒伪劣产品出现，应在第一时间内通知甲方，并协助甲方进行打假活动。</p><p>8、乙方必须掌握产品的流量、流向等动态信息，以便甲方核查。为保证信息及时性，甲方将投入物流信息采集系统、金徽积分宝，乙方须积极配合落实。甲方将根据乙方录入产品信息核算</p><p>相关激励政策额度。</p><p>9、乙方在经销过程中非因甲方产品质量问题引起的消费者投诉和有关违约、侵权赔偿请求，均由乙方自行承担相关的责任。</p><p>10、乙方保证按期完成销售任务，如未能按期完成，甲方有权扣除对乙方的激励政策支持。</p><p>11、乙方不得擅自印制并对外发放有关甲方及甲方产品的任何宣传信息及资料，否则甲方有权扣除乙方缴纳的合同保证金。</p><p>12、乙方保证遵守甲方下发的各项针对乙方的管理制度，如有违反将接受甲方的各项处罚。</p><p><br></p><p>九、日常管理及考核</p><p>1、甲方制定《2020 年度经销商管理办法》作为甲方对乙方日常各项义务考核的依据文件。</p><p>2、甲方依据该文件对乙方进行日常管理及考核。</p><p><br></p><p>十、违约责任</p><p>1、如甲方向乙方提供有瑕疵的产品，乙方有权要求甲方予以调换（不可抗力因素除外）。</p><p>2、乙方若违反本合同规定的价格体系，低价倾销甲方产品的，甲方依据《2020年度经销商管理办法》规定给予乙方处罚。</p><p>3、乙方若违反本合同规定跨区域销售的，乙方应按照《2020 年度倒窜货管理办法》规定承担责任。</p><p>4、若经甲方调查核实，乙方销售假冒伪劣的甲方产品，甲方有权扣除乙方全额合同保证金，同时取消乙方的经销权，甲方不再向乙方兑现本合同及其他书面确认的任何承诺。</p><p>5、乙方连续 30 天内不从甲方进货，或连续 3 个月未完成甲方下达销售任务的 80%，甲方有权终止合同。</p><p>6、乙方若违反本合同规定，从其他方进货的，需向甲方支付违约金（违约金为合同保证金的 40%，直接从合同保证金中扣除）。</p><p>7、乙方擅自向他人泄露或者允许他人使用其所掌握的甲方的商业秘密的，需向甲方支付违约金人民币壹万元（直接从合同保证金中扣除）。</p><p>8、如甲乙双方约定为乙方发展团购经销商，所有团购经销商年度总销售额不得超过乙方年度总销售额的 60%，如所有团购经销商年度总销售超过以上比例，甲方将按照约定向团购经销商兑现激励政策，同时有权将超额兑付的激励政策从乙方的各项销售激励政策中扣除。</p><p>9、如甲乙双方约定为乙方发展酒店业务，甲方业务人员只负责酒店业务的拓展及酒店客户的维护；乙方与酒店发生的债权、债务问题，与甲方及甲方业务人员无关。</p><p>10、乙方违反本合同其它条款的，也应承担相应的违约责任。</p><p><br></p><p>十一、合同保证金约定</p><p>1、经甲、乙双方协商，乙方自愿交纳 万元作为代理、使用、维护甲方产品及品牌和遵守甲方相关管理制度的合同保证金。</p><p>2、本合同期限届满，如甲乙双方不再续签合同，乙方无任何违约行为，则甲方须两个月内退还乙方全额合同保证金。</p><p>3、本合同期限届满，如甲乙双方仍续签合同，则甲方须按新合同约定向乙方收足合同保证金或退还超出的合同保证金。</p><p>4、合同保证金不计息。</p><p>5、因乙方违约被扣除保证金导致合同保证金金额不足的，乙方应在五个工作日内补足差额部分。</p><p>6、对乙方合同保证金的扣罚不排斥甲方对乙方其他违约行为和侵权行为的法律主张。</p><p>十二、乙方未按照国家法律、法规及规范性文件的规定办理相关资质证件、许可文件或者批准文件或者未按照营业执照记载的经营范围开展经营活动的，</p><p>由此造成的全部法律后果及给金徽酒各销售公司、金徽酒股份有限公司造成的经济损失由乙方承担。</p><p>十三、保密条款：双方在合作过程中，获取的任何对方的信息（包括但不限于企业情况、供应商情况、产品供应价格、各项激励政策等信息）在任何情况下不得向第三方公开；否则，违约方向守约方支付壹万元违约金，违约金的支付不影响守约方主张其他法律权利。</p><p>十四、本合同条款、名词含义的解释权归甲方所有。</p><p>十五、本合同含附件一《备案登记》、附件二《销售目标与激励政策》，附件与本合同效力等同。其他未尽事宜，双方另行订立补充协议，补充协议与本合同效力等同。</p><p>十六、本合同履行过程中引起的争议，双方协商解决，协商不成的，双方约定向合同签订地人民法院起诉。</p><p>十七、本合同一式四份，甲方执三份，乙方执一份，具有同等法律效力。</p><p>十八、本合同经甲乙双方签字盖章并自乙方缴纳全额合同保证金到甲方指定账户之日起自行生效，若自合同签订之日起七个工作日内，乙方全额合同保证金未到甲方账户，本合同自行解除。本合同生效后，之前签订的同类合同、约定及洽谈协议等均自行终止。</p>',
    };
  },

  mounted() {
    this.getFormRule(this.functionName, this.parentCode);
  },

  methods: {
    setRule(v) {
      const rowData = v;
      if (rowData.field === 'modalTitle') {
        rowData.props = {
          title: this.titleName || rowData.title,
        };
      } else {
        rowData.props = {
          ...rowData.props,
          config: {
            height: 500,
          },
        };
      }
      rowData.props = {
        ...rowData.props,
        disabled: this.formType === 'view',
      };
      return rowData;
    },
    setFormValue(val, data) {
      this.configureData = {
        ...val[0],
      };
    },
    formComplete() {
      if (this.configureData) {
        this.setValue(this.configureData);
      } else {
        this.setValue({
          contractDetails: this.defaultValue,
        });
      }
    },
  },
};
</script>
